import script from "./AnnouncementsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementsTable.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementsTable.vue?vue&type=style&index=0&id=625bb326&lang=scss&scoped=true"
script.__scopeId = "data-v-625bb326"

export default script